import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/button';
import { ActionSheet } from '@components/scheduling/actionSheet';
import { PhoneDiscardSheetProps } from './types';

export const PhoneDiscardSheet = ({
  open,
  onDismiss,
  onSaveDraft,
  onDiscard,
  locked,
}: PhoneDiscardSheetProps) => {
  const { t } = useTranslation('app');

  return (
    <ActionSheet
      open={open}
      onDismiss={onDismiss}
      title={t('scheduling.phone.discardTitle')}
      actions={
        <div className="!grid-cols-1">
          {onSaveDraft && (
            <Button disabled={locked} onClick={onSaveDraft}>
              {t('actions.saveAsDraft')}
            </Button>
          )}
          <Button
            variant="secondary"
            className="border-danger-200 text-danger-600"
            onClick={onDiscard}>
            {t('actions.discard')}
          </Button>
          <Button variant="ghost" className="bg-neutral-50" onClick={onDismiss}>
            {t('scheduling.phone.keepEditing')}
          </Button>
        </div>
      }
    />
  );
};
